import React from 'react';
import './Style/Contact.css';
import TopNavbar from './../home/TopNavbar';

const Contact = () => {
  return (
    <div className="contact-container">
      
      <TopNavbar name="Contact Us" />
      
      <div className="contact-card">
        
        {/* Header */}
        <header className="contact-header">
          <h1 className="contact-title">Contact Us</h1>
          <p className="contact-subtitle">
            Have questions or feedback about your JEE Main & Advanced preparation? We are here to help!
          </p>
        </header>

        {/* Contact Options */}
        <div className="contact-grid">
          
          {/* Email Box */}
          <div className="contact-item-card">
            <div className="contact-icon" aria-hidden="true">📧</div>
            <h2>Email Us</h2>
            <p>For support, feedback, feature requests, or general inquiries:</p>
            <a href="mailto:contact@mystudyplace.in" className="contact-link">
              contact@mystudyplace.in
            </a>
          </div>

        </div>

        {/* Footer Note */}
        <footer className="contact-footer">
          <p>Part of the <strong>JEE Mock Test</strong> App ecosystem.</p>
        </footer>

      </div>
      
    </div>
  );
};

export default Contact;